module.exports = __webpack_public_path__ + "media/printed-materials/educators-03-fastwebs-app-onepage-2107cdb4.jpg";